import {FormValidator, SpecificValidationMessages} from './form-validator.class';
import {Observable} from 'rxjs';
import {NgForm} from '@angular/forms';
import {MyRequiredValidatorDirective} from './required/required-validator.directive';
/**
 * Created by Rodrigo Quesada on 21/12/16.
 */

let defaultValidationMessages = {
    'required': MyRequiredValidatorDirective.ERROR_MESSAGE
};

export class DefaultFormValidator extends FormValidator {

    constructor(form$: Observable<NgForm>, specificValidationMessages$: Observable<SpecificValidationMessages> = Observable.of({})) {
        super(form$, defaultValidationMessages, specificValidationMessages$);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/default-form-validator.class.ts